var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rs"},[_c('span',{staticClass:"rs-stars",attrs:{"aria-label":`${_vm.score}/${_vm.max}`}},_vm._l((_vm.max),function(star){return _c('i',{key:star,staticClass:"rs-star",class:star <= _vm.score ? 'fas fa-star' : 'fal fa-star'})}),0),_c('span',{staticClass:"rs-score"},[_vm._v(_vm._s(_vm.score)+"/"+_vm._s(_vm.max))])])
}
var staticRenderFns = []

export { render, staticRenderFns }